import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center q-gutter-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "～", -1)

import { ref, watch, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    placeholder: null,
    qa: null,
    qb: null,
    qc: null,
    qd: null,
    qe: null,
    required: { type: Boolean },
    readonly: { type: Boolean },
    suffix: null,
    prefix: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { placeholder?: string, qa?: string, qb?: string, qc?: string, qd?: string, qe?: string, required: boolean, readonly?: boolean, suffix?: string, prefix?: string, modelValue: string | null }





const innerModelValue = ref(['', ''])

watch(
  () => props.modelValue,
  () => {
    innerModelValue.value = Object.assign(['', ''], props.modelValue?.split('～').splice(0, 2) ?? [])
  },
  { immediate: true },
)

watch(
  () => innerModelValue,
  () => {
    emit('update:modelValue', innerModelValue.value.join('～'))
  },
  { deep: true },
)

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_input, {
        readonly: __props.readonly,
        type: "number",
        inputmode: "decimal",
        dense: "",
        outlined: "",
        prefix: __props.prefix,
        suffix: __props.suffix,
        class: "col",
        modelValue: innerModelValue.value[0],
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerModelValue.value[0]) = $event))
      }, null, 8, ["readonly", "prefix", "suffix", "modelValue"]),
      _hoisted_2,
      _createVNode(_component_q_input, {
        readonly: __props.readonly,
        type: "number",
        inputmode: "decimal",
        dense: "",
        outlined: "",
        prefix: __props.prefix,
        suffix: __props.suffix,
        class: "col",
        modelValue: innerModelValue.value[1],
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((innerModelValue.value[1]) = $event))
      }, null, 8, ["readonly", "prefix", "suffix", "modelValue"])
    ])
  ]))
}
}

})